import React, { Component } from 'react'
import { Button } from '@tinper/next-ui'
import { ENV_RENDER_DESIGNER } from '@utils/constants'
import { TableStore, RowStore, PageStore } from 'ynf-core-engine'
import render from 'ynf-core-engine/render';
import request from 'ynf-core-engine/request';
import { v4 as uuid } from 'uuid'
import './style/index.less'
const { ROW_KEY = 'id'} = {}

const REFER_LIB_CODE = 'ynf-fw-apcom-lib'
const LIST_LIB_CODE = 'ynf-lib-base' // 组件库名
export default class DownloadTpl extends Component {
  state = {
    modalVisible: false,
    columns: [
      {
        cItemName: 'tplVersion',
        caption: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800AB', '版本', undefined, {returnDom: true, placement: 'top'}),
        iColWidth: 110,
        bHidden: false,
        bShowIt: true,
        bCanModify: false,
        controlType: 'Input',
        libCode: 'ynf-lib-base',
        storeField: 'tplVersion',
        bMustSelect: true,
        bIsNull: true,
store: '_table'
      },
      {
        cItemName: 'code',
        caption: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800A3', '模板编号', undefined, {returnDom: true, placement: 'top'}),
        iColWidth: 120,
        bHidden: false,
        bShowIt: true,
        bCanModify: false,
        controlType: 'Input',
        libCode: 'ynf-lib-base',
        storeField: 'code',
        bMustSelect: true,
        bIsNull: true,
store: '_table'
      },
      {
        cItemName: 'name',
        caption: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800A9', '模板名称', undefined, {returnDom: true, placement: 'top'}),
        iColWidth: 100,
        bHidden: false,
        bShowIt: true,
        bCanModify: false,
        controlType: 'Input',
        libCode: 'ynf-lib-base',
        storeField: 'name',
        bMustSelect: true,
        bIsNull: true,
store: '_table'
      },
      {
        cItemName: 'parentTplName',
        caption: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800B0', '模板来源', undefined, {returnDom: true, placement: 'top'}),
        iColWidth: 100,
        bHidden: false,
        bShowIt: true,
        bCanModify: false,
        controlType: 'Input',
        libCode: 'ynf-lib-base',
        storeField: 'parentTplName',
        bMustSelect: true,
        bIsNull: true,
store: '_table'
      },
      {
        cItemName: 'transType',
        caption: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800A7', '交易类型', undefined, {returnDom: true, placement: 'top'}),
        iColWidth: 100,
        bHidden: false,
        bShowIt: true,
        bCanModify: false,
        controlType: 'Input',
        libCode: 'ynf-lib-base',
        storeField: 'transType',
        bMustSelect: true,
        bIsNull: true,
store: '_table'
      },
      {
        cItemName: 'createTime',
        caption: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800AE', '创建时间', undefined, {returnDom: true, placement: 'top'}),
        iColWidth: 140,
        bHidden: false,
        bShowIt: true,
        bCanModify: false,
        controlType: 'Input',
        libCode: 'ynf-lib-base',
        storeField: 'createTime',
        bMustSelect: true,
        bIsNull: true,
store: '_table'
      },
      {
        cItemName: 'updateTime',
        caption: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800A6', '更新时间', undefined, {returnDom: true, placement: 'top'}),
        iColWidth: 140,
        bHidden: false,
        bShowIt: true,
        bCanModify: false,
        controlType: 'Input',
        libCode: 'ynf-lib-base',
        storeField: 'updateTime',
        bMustSelect: true,
        bIsNull: true,
store: '_table'
      },
      {
        cItemName: 'operatorName',
        caption: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800AC', '操作人', undefined, {returnDom: true, placement: 'top'}),
        iColWidth: 100,
        bHidden: false,
        bShowIt: true,
        bCanModify: false,
        controlType: 'Input',
        libCode: 'ynf-lib-base',
        storeField: 'operatorName',
        bMustSelect: true,
        bIsNull: true,
store: '_table',
      },
      {
        cItemName: 'devStatus',
        caption: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800A4', '状态', undefined, {returnDom: true, placement: 'top'}),
        iColWidth: 60,
        bHidden: false,
        bShowIt: true,
        bCanModify: false,
        controlType: 'Input',
        libCode: 'ynf-lib-base',
        storeField: 'devStatus',
        bMustSelect: true,
        bIsNull: true,
store: '_table',
      },
      {
        cItemName: 'devSystemTpl',
        caption: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800AA', '是否默认模板', undefined, {returnDom: true, placement: 'top'}),
        iColWidth: 100,
        bHidden: false,
        bShowIt: true,
        bCanModify: false,
        controlType: 'Input',
        libCode: 'ynf-lib-base',
        storeField: 'devSystemTpl',
        bMustSelect: true,
        bIsNull: true,
store: '_table',
      }
      // {
      //   cItemName: 'devAllInOneSheet',
      //   caption: '模板形式',
      //   iColWidth: 130,
      //   bHidden: false,
      //   bShowIt: true,
      //   bCanModify: false,
      //   controlType: 'Input',
      //   // enumArray: '[{"nameType":"text","value":"多页签","key":"true"},{"nameType":"text","value":"单页签","key":"false"}]',
      //   bMustSelect: false,
      //   bIsNull: true,
      // }
    ],
    tplData: [],
    selectedRowIndex: 0,
    selectedList: {},
    tableAlias: uuid(),
    defaultKey: '',
    rootStore: {}
  }

  selectedObj = {}

  setModal = (visible = true) => {
    const { renderEnv } = this.props
    const isDesigner = renderEnv === ENV_RENDER_DESIGNER
    if (!isDesigner) {
      this.setState({ modalVisible: visible }, () => {
        this.getTemplateList()
      })
    }
  }

  // 获取模板列表
  getTemplateList = async () => {
    // this.props.cookies.set('zone', 'check152liuhaoixport', {path: '/iuap-metadata-import/exceltrain'})
    const { pageStore } = this.props
    const res = await request({
      method: 'post',
      url: '/iuap-metadata-import/exceltrain/template/getTplList',
      params: {
        feV: 6,
        currentDomainKey: pageStore?.params?.domainKey,
        terminalType: pageStore?.query?.terminalType,
        busiObj: pageStore?.params?.busiObj
        // designPreview: true
      },
      data: {
        billnum: pageStore?.params?.detailBillNo || pageStore?.params?.billNo
      }
    }, {
      proxy: false,
      rawResponse: false,
      handleErrCode: true
    })
    if (res.code !== 200) {
      // quantum.utils.err(res.message || '获取模板失败')
      return
    }
    let tplData = res?.data || []
    let defaultKey = ''
    let selectObjCont = {}
    tplData = tplData.map(row => {
      // 处理状态
      row.devStatus = row.published || row.systemTpl ? lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800B2', '已发布', undefined, {returnDom: true, placement: 'top'}) : lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800B1', '未发布', undefined, {returnDom: true, placement: 'top'})
      // 处理预置数据
      row.devSystemTpl = lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800B3', '否', undefined, {returnDom: true, placement: 'top'})
      row[ROW_KEY] = row?.id || uuid()
      if (row.isDefault) {
        defaultKey = row[ROW_KEY]
        selectObjCont = { ...row }
        row.devSystemTpl = lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800A5', '是', undefined, {returnDom: true, placement: 'top'})
      }
      return row
    })
    defaultKey = defaultKey || tplData?.[0][ROW_KEY]
    this.selectedObj = {
      selectedList: { ...(selectObjCont || tplData?.[0]) },
      selectedRowIndex: defaultKey
    }
    this.setState({ tplData, defaultKey })
  }

  // 下载模板
  handleDownload = async () => {
    // 从node层提供的参数 拿到domianKey对应的微服务
    const httpParam = window.__DOMAIN_URL__
    const { pageStore } = this.props
    // this.props.cookies.set('zone', 'check152liuhaoixport', {path: '/bpd-check-ld-be/billtemp/'})
    const { selectedList = {} } = this.selectedObj
    const { tplId = '', systemTpl, published, templateType, name, billnum, domainKey, downloadType } = selectedList

    if (!tplId && !systemTpl) {
      // quantum.utils.info('请选择要下载的模板')
      return // 没有选中行
    }

    if (!systemTpl && !published) {
      // quantum.utils.info('您选择的模板尚未发布')
      return
    }

    request({
      method: 'post',
      url: `${httpParam}/billtemp/export`,
      params: {
        feV: 6,
        currentDomainKey: pageStore?.params?.domainKey,
        ...pageStore?.query
      },
      responseType: 'blob',
      data: {
        tplid: systemTpl ? null : tplId, // 如果是系统模板，就取下载模板自带的，否则就是自定义的，取行里面的
        fromUniteEntrance: true, // 是否是从实施工具过去的，(后端需要)
        systemTpl, // 系统模板
        billnum,
        templateType,
        fileType: 'excel', // 导出文件类型downloadType
        filename: name // 文件名
        // allInOneSheet: false, // 单页签or多页签模板 刘豪接口不需要
      }
    }, {
      proxy: false,
      rawResponse: false,
      handleErrCode: true,
      silent: true
    }).then(result => {
      // result ：Blob实例
      this.exportFile(result, name)
      // quantum.utils.suc('操作成功')
    }).catch(err => {
      // result ：Blob实例 TODO: request中应配置此种情况
      this.exportFile(err, name)
      // console.log('err--', err || err?.message || '操作失败')
      // rootStore.utils.danger(err || err?.message || '操作失败')
    })
  }

  /**
   * 导出文件
   * @param {*} data 接口返回数据
   * @param {*} filename 下载文件名
   */
  exportFile = (data, filename) =>
    new Promise((resolve, reject) => {
      const type = data?.type
      if (type.includes('application/json')) {
        const reader = new FileReader()
        reader.readAsText(data)
        reader.onload = () => {
          const content = reader.result
          const message = JSON.parse(content) // 错误信息
          reject(message)
        }
      } else {
        // const blob = new Blob([data]) 因为responseType指定接口返回就是Blob实例，所以不用重复创建实例
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(data, filename)
        } else {
          const elink = document.createElement('a')
          elink.download = filename
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(data)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        }

        resolve()
      }
    })

  // 模板列表配置项
  getTableConfig = () => {
    const { columns, tableAlias, tplData, defaultKey, rootStore } = this.state
    const { selectedRowIndex } = this.selectedObj
    rootStore._table = new TableStore({}, rootStore)
    tplData.forEach((item, index) => {
      rootStore._table.addRow(new RowStore(index, item))
    })
    return {
      libCode: LIST_LIB_CODE, // 组件库
      controlType: 'Table', // 组件类型
      referenceType: 'model', // 兼容合计
      alias: tableAlias,
      showRowNum: true, // 显示行号
      children: columns, // 表头
      selectedRowIndex, // 当前选中行【单选】
      autoCheckedByClickRows: true, // 点击行即可选中
      hidePagination: true,
      store: rootStore._table,
      rowSelection: {
        selectedRowKeys: [defaultKey], // 指定选中项的 key 数组
        multiple: false // 单选
      },
      getSelectedDataFunc: (selectedList, selectedRowIndex) => { // 单选 返回当前选中的数据数组
        // this.setState({ selectedRowIndex, selectedList })
        // this.props.ctx.apis.store.updateViewState(tableAlias,'selectedRowIndex',selectedRowIndex)
        // 注意：需要用回调中提供的参数 newData，去更新 state 或 store 中的 data 属性值，否则当表格重新render的时候，已选数据会被冲刷掉。
        this.selectedObj = { selectedList, selectedRowIndex }
      }
    }
  }

  getFieldId = () => {
    const { fieldid, fieldidPrefix } = this.props || {};
    return fieldid || fieldidPrefix;
  }

  // 渲染弹窗内容
  renderChildren = () => {
    const { pageStore } = this.props
    return (
      <div className='tpl-content'>
        <div className='tpl-btns'>
          <Button fieldid={this.getFieldId()} colors="success" onClick={this.handleDownload}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800AD', '下载模板', undefined, {returnDom: true, placement: 'top'})}</Button>
          {/* <Button fieldid={this.getFieldId()}><a href="blob:https://bip-test.yyuap.com/5471dd0e-9798-4985-86e0-34b2f49db72c" download="测试导入.xls">设置默认</a></Button> */}
        </div>
        {
          render(this.getTableConfig(), { rootStore: this.state.rootStore })
        }
      </div>
    )
  }

  getFieldId = () => {
    const { fieldid, fieldidPrefix } = this.props || {};
    return fieldid || fieldidPrefix;
  };

  render () {
    const { modalVisible } = this.state
    const modalConfig = {
      libCode: REFER_LIB_CODE,
      controlType: 'CommonPicker',
      height: '550px',
      width: '950px',
      title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800A8', '下载/制作模板', undefined, {returnDom: true, placement: 'top'}),
      isShowFooter: false,
      alias: uuid(),
      className: 'download-tpl-modal',
      close: () => {
        return new Promise((resolve, _reject) => {
        setTimeout(() => {
          this.setState({ modalVisible: false })
          resolve(true);
        }, 100);
      });
      },
      visible: modalVisible
    }
    return (
      <div className='download_tpl' ref={e => this.importRef = e}>
        <Button className="yb_download_btn" fieldid={`${this.getFieldId()}`} onClick={this.setModal}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A800AF', '模板下载', undefined, {returnDom: true, placement: 'top'})}</Button>
        {
          render(modalConfig, {
            children: this.renderChildren()
          })
        }
      </div>
    )
  }
}
